import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { HeaderHelperOptions } from '@base-interfaces/header-helper';
import { AuthService } from './auth.service';
import { get } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  iconSet: Subject<HeaderHelperOptions> = new Subject<HeaderHelperOptions>();
  panelOpen: Subject<any> = new Subject<any>();
  panelClose: Subject<any> = new Subject<any>();
  titleSet: Subject<any> = new Subject<any>();
  tabTitleSet: Subject<any> = new Subject<any>();
  displayHeader: Subject<any> = new Subject<any>();
  quickBack: Subject<any> = new Subject<any>();

  breadcrumbsListener: BehaviorSubject<any> = new BehaviorSubject<any>({});

  set showSubheader(value: Boolean) {
    localStorage.setItem('eyrus-show-subheader', value.toString());
  }

  get showSubheader() {
    const display = localStorage.getItem('eyrus-show-subheader');
    const show = (display === 'true' || display === null) ? true : false;

    return show;
  }

  displaySubHeader: BehaviorSubject<any> = new BehaviorSubject<any>({
    display: false,
    close: false,
    message: '',
    userType: 'reviewer',
    bannerType: 'trial'
  });

  constructor(
    private authService: AuthService,
  ) { }

  /**
   * Emit icon name to header component
   * @param options Name of current icon
   */
  setIcon(options: HeaderHelperOptions) {
    this.iconSet.next(options);
  }

  /**
   * Notify to side panel that should be opened
   */
  openSidePanel() {
    this.panelOpen.next();
  }

  /**
   * Notify to side panel that should be closed
   */
  closeSidePanel() {
    this.panelClose.next();
  }

  /**
   * Notify to header component that a title should be replaced
   * @param title new title
   */
  setTitle(title) {
    this.titleSet.next(title);
  }

  /**
   * Notify to display or hide header
   * @param display boolean
   */
  setDisplay(display) {
    this.displayHeader.next(display);
  }

  checkSubBanner() {
    const currentUser = get(this.authService, 'user') || {};
    const account = currentUser.accounts.find(e => {
      return e.accountId.toString() === this.authService.accountId.toString();
    });

    if (!account)
      return;

    const options = {
      // display: account.isTrialing && this.showSubheader,
      account,
      ...this.getSubheaderOptions(account)
    };

    this.displaySubHeader.next(options);
  }

  private getSubheaderOptions(account) {
    const userType = account.assignedContractTypes.indexOf('reviewer') !== -1 ? 'reviewer'
      : account.assignedContractTypes.indexOf('admin') !== -1 ? 'admin' : 'submitter';

    const bannerType = account.lockoutDateTimeUtc ? 'locked' : 'trial';

    const display = (account.isTrialing && this.showSubheader) || (bannerType === 'locked');
    // const close = bannerType === 'trial' ? true : false;
    const close = true;
    return { close, userType, bannerType, display };
  }

}
